module.exports = __webpack_public_path__ + "img/crash.dc3b6a5a.webp";